"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Enums_1 = require("../Enums");
var HighlightProprietaire_1 = __importDefault(require("../Mixins/HighlightProprietaire"));
exports.default = {
    props: {
        proprietaire: Object
    },
    mixins: [HighlightProprietaire_1.default],
    data: function () {
        return {
            TypeDroitProprieteEnum: Enums_1.TypeDroitProprieteEnum
        };
    },
    methods: {
        getRegimePropriete: function () {
            var regime = this.proprietaire.RegimePropriete;
            return Enums_1.TypeDroitProprieteEnum[regime] && Enums_1.TypeDroitProprieteEnum[regime].text || regime;
        },
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/ResumeProprietaire.vue
// module id = 236
// module chunks = 0